<template>
  <div class="tinymce-box">
    <editor v-model="myValue" :init="init">请输入</editor>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/icons/default/icons";
import "tinymce/plugins/image"; // 插入上传图片插件
// import 'tinymce/plugins/media'; // 插入视频插件
// import 'tinymce/plugins/table'; // 插入表格插件
// import 'tinymce/plugins/lists'; // 列表插件
// import 'tinymce/plugins/wordcount'; // 字数统计插件

// 引入富文本编辑器主题的js和css
import "tinymce/themes/silver/theme.min.js";
import { editorResourceUrl } from "../../../utils/common.js";
// import 'tinymce/icons/default/icons' // 解决了icons.js 报错Unexpected token '<'
export default {
  name: "Tinymce",
  data() {
    return {
      myValue: this.value,
      init: {
        language_url: `${this.baseUrl}/tinymce/langs/zh_CN.js`,
        language: "zh_CN",
        skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
        convert_urls: false,
        height: 214,
        plugins: "image",
        menubar: false,
        toolbar: "image", // （自定义工具栏）
        branding: false, // （隐藏右下角技术支持）水印“Powered by TinyMCE”
        // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: (blobInfo, success, failure) => {
          const img = "data:image/jpeg;base64," + blobInfo.base64();
          success(img);
          console.log(failure);
        },
      },
    };
  },
  props: {
    data: {
      type: String,
      default: "",
    },
    baseUrl: {
      type: String,
      default: editorResourceUrl(),
    },
  },

  components: {
    Editor,
  },
  computed: {},
  methods: {
    getContent() {
      return this.myValue;
    },
  },
  mounted() {
    tinymce.init({});
    this.myValue = this.data;
  },
  created() {
    if (localStorage.getItem("lang") == "en") {
      this.init.language = "en";
    } else {
      this.init.language = "zh_CN";
      this.lange = "zh_CN";
    }
    // console.log(this.lange);
  },
  watch: {
    myValue(newValue, oldValue) {
      // console.log(oldValue, newValue);
    },
    data(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.myValue = newValue;
      }
    },
    deep: true,
  },
};
</script>
<style scoped></style>
